<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-card>
      <v-card-title>
        Editar item ao contrato
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <p class="subtitle-1 font-weight-bold mt-5">
            {{ parameters.education_hierarchy_name }}
          </p>
        </div>
        <div class="d-flex">
          <v-checkbox
            label="Conteudos de vídeo"
            v-model="parameters.has_media"
            class="pr-4"
          />
          <v-checkbox
            label="Atividades"
            v-model="parameters.has_activity"
          />
        </div>
        <div class="d-flex">
          <v-checkbox
            label="Banco de questões"
            v-model="parameters.has_question_bank"
            class="pr-4"
          />
          <v-checkbox
            label="Material didático"
            v-model="parameters.has_textbook"
          />
        </div>
        <div class="d-flex">
          <v-select
            v-model="parameters.publishing_year"
            class="px-2"
            :items="years"
            :disabled="!parameters.has_textbook"
            item-text="name"
            item-value="value"
            label="Ano do material(teorico)"
          />
          <v-select
            v-model="parameters.publishing_year_additional"
            class="px-2"
            :items="years"
            :disabled="!parameters.has_textbook"
            item-text="name"
            item-value="value"
            label="Ano do material(complementares)"
          />
        </div>

        <div class="d-flex align-center justify-space-between mt-10">
          <v-btn
            depressed
            color="error"
            plain
            @click="deleteItem()"
          >
            excluir
          </v-btn>
          <v-btn
            depressed
            @click="onCancel()"
          >
            fechar
          </v-btn>
          <v-btn
            depressed
            @click="updateContractItem()"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  components: {
  },

  props: {
    contractItem: { type: Object, required: true }
  },

  data: () => ({
    parameters: {
      education_hierarchy_name: null,
      publishing_year: null,
      publishing_year_additional: null,
      has_media: true,
      has_activity: true,
      has_question_bank: true,
      has_textbook: true
    },
    years: [
      new Date().getFullYear() + 1,
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2,
      new Date().getFullYear() - 3,
      new Date().getFullYear() - 4,
      new Date().getFullYear() - 5,
      new Date().getFullYear() - 6
    ],
    shouldContinue: false
  }),
  watch: {
    contractItem: {
      handler (contractItem) {
        this.parameters.education_hierarchy_name = contractItem.grade.name + ' - ' + contractItem.grade.education_stage.name + ' - ' + contractItem.grade.education_stage.education_system.name
        this.parameters.has_textbook = contractItem.has_textbook
        this.parameters.has_media = contractItem.has_media
        this.parameters.has_activity = contractItem.has_activity
        this.parameters.has_question_bank = contractItem.has_question_bank
        this.parameters.publishing_year = contractItem.publishing_year
        this.parameters.publishing_year_additional = contractItem.publishing_year_additional
      },
      immediate: true
    }
  },
  computed: {
  },

  created () {
  },

  methods: {

    async deleteItem () {
      this.$dialog.confirm('Apagar item do contrato?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.deleteContractItem(this.contractItem.id)
            this.$store.dispatch('setSnackBar', { text: 'Item do contrato excluido com sucesso.' })
            this.$emit('resolve', true)
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível Excluir, tente novamente mais tarde.', color: 'red' })
          }
        })
        .show()
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    async updateContractItem () {
      try {
        await this.$api.updateContractItem(this.contractItem.id, this.parameters)
        this.shouldC()
      } catch (error) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar o item do contrato, tente novamente mais tarde.', color: 'red' })
      }
      // this.shouldC()
    },
    shouldC () {
      if (this.shouldContinue) {
        this.$refs.gradeSelect.grade_id = null
        return
      }
      this.$emit('resolve', true)
    }
  }
}
</script>
